export const Career = () =>{
    return(
        <div className="flex justify-center items-center h-screen ">
            <h1 className="text-2xl font-primary font-semibold">There is no opening. Check back later!</h1>
        </div>
    )
}